import { render, staticRenderFns } from "./createFrom.vue?vue&type=template&id=21fcd4b6&scoped=true"
import script from "./createFrom.vue?vue&type=script&lang=js"
export * from "./createFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fcd4b6",
  null
  
)

export default component.exports